import { axiosWithPasetoAuth } from '@telialt/utils/src/authentication/axiosWithPasetoAuth';
import { axiosForAnonymousHudson } from '@telialt/utils/src/axios/axiosForAnonymousHudson';
import { withParams } from '@telialt/utils/src/helpers';
import { TeliaSegment } from '@telialt/utils/src/segment';

import { API } from './constants';
import { UniqueOfferDocumentRequestParams, UniqueOfferWithMsisdnDocumentRequestParams } from './model';

export const apiGetUniqueOfferDocument = (segment: TeliaSegment, params: UniqueOfferDocumentRequestParams) => {
    return axiosForAnonymousHudson.get<{ fileUrl: string }>(withParams(API.URL_UNIQUE_OFFER_DOCUMENT_ID, { segment }), {
        params,
    });
};

export const apiGetUniqueOfferSSDocument = (
    segment: TeliaSegment,
    { msisdn, ...params }: UniqueOfferWithMsisdnDocumentRequestParams,
) => {
    return axiosWithPasetoAuth.get<{ fileUrl: string }>(
        withParams(API.URL_UNIQUE_OFFER_SS_DOCUMENT_ID, { msisdn, segment }),
        { params },
    );
};
